import React, {Component, Fragment} from 'react'
import {Breadcrumb, Button, Card, Row, Tabs} from 'antd'
import style from '../style.css'
import {get} from 'lodash'
import IconText from '../../../elements/IconText'
import {withRouter} from 'react-router-dom'
import ExportCSVComponent from '../../../components/Finance/Reports/steps/ExportCSVComponent'

const {TabPane} = Tabs

class Reports extends Component {
  render() {
    const {fetchingInvoices, fetchInvoices} = this.props

    return (
      <Fragment>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Finance</Breadcrumb.Item>
              <Breadcrumb.Item>Reports</Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>Finance Reporting Overview</h2>
            <p className={style.paragraph}>
              View and export reports finance details.
            </p>
          </Row>
        </Card>
        <Card className={style.contentCard}>
          <Tabs
            defaultActiveKey={get(this.props, 'location.hash') || '#invoices'}
            onChange={key => this.props.history.push(key)}>
            <TabPane
              tab={<IconText text={'Invoices'} type={'book'} />}
              key="#invoices">
              <ExportCSVComponent
                {...this.props}
                fetch={fetchInvoices}
                fetching={fetchingInvoices}
              />
            </TabPane>
            <TabPane
              disabled={true}
              tab={<IconText text={'Payments'} type={'file-text'} />}
              key="#transactions"
            />
          </Tabs>
        </Card>
      </Fragment>
    )
  }
}

Reports.propTypes = {}
Reports.defaultProps = {}

export default withRouter(Reports)
